import { MassMessageRecipientConnection } from 'models';

function hasConnection(
  connections: MassMessageRecipientConnection[],
  testedConnection: MassMessageRecipientConnection
) {
  return connections.some((connection) => {
    return (
      connection.RoleId === testedConnection.RoleId &&
      connection.TargetId === testedConnection.TargetId
    );
  });
}

/**
 * @param connections Connections` list
 * @returns List of unique connections
 *
 * Due to peculiar CRM behaviour
 * that can lead to duplicate connections,
 * we're using this function to secure ourself
 * from unexpected consequences
 *
 * A unique connection is a connection with
 * unique role id and target id
 */
export default function getUniqueConnections(
  connections: MassMessageRecipientConnection[]
) {
  let uniqueConnections: MassMessageRecipientConnection[] = [];

  for (let connection of connections) {
    if (!hasConnection(uniqueConnections, connection)) {
      uniqueConnections.push(connection);
    }
  }

  return uniqueConnections;
}
